import { useMemo } from 'react';
import getColumnWidth from '../get-column-width';

const useBlocks = (blocks, fn) => {
  const result = useMemo(() => {
    const activeBlocks = (blocks || []).filter(Boolean);
    let offset = 0;
    const blocksWithoutEmpty = activeBlocks.reduce((acc, block) => {
      // eslint-disable-next-line no-underscore-dangle
      if (block.__typename === 'StrapiPagebuilderPagebuilderBlocksEmpty') {
        offset = getColumnWidth(block.columnWidth);
        return acc;
      }
      if (offset !== 0) {
        const blockWithOffset = {
          ...block,
          offset,
        };
        offset = 0;
        return acc.concat(blockWithOffset);
      }
      return acc.concat(block);
    }, []);
    return blocksWithoutEmpty.map((block) => fn(block));
  }, [
    blocks,
    fn,
  ]);

  return result;
};

export default useBlocks;
